import React from "react";

import { Icon, IconButton } from "./ui";
import { openUserEditTab } from "../helpers/userEditTab";
import "./edit-user-button.scss";

/**
 * Opens the user's edit form (Users CRM detail drawer, Contact tab) in a new
 * browser tab. Used from every user-selection surface in the flows — the
 * picker rows and the already-selected user — so a rep can fix a name, type,
 * store, email or phone without losing the deal they are half-way through.
 *
 * The pointer handlers are deliberately loud: this button lives inside a
 * clickable table row and inside a select option, and neither must select
 * anything when the icon is what was clicked. A select acts on mousedown, so
 * stopping click alone is not enough.
 */
const EditUserButton = ({ user, className = "", label = "Edit user" }) => {
  const id = typeof user === "object" && user !== null ? user.id : user;
  if (!id) return null;

  const swallow = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <IconButton
      size="sm"
      label={label}
      title={label}
      className={className}
      data-btn="user-edit"
      onMouseDown={swallow}
      onTouchStart={swallow}
      onClick={(e) => {
        swallow(e);
        openUserEditTab(user);
      }}
    >
      <Icon name="Pencil" size="sm" />
    </IconButton>
  );
};

export default EditUserButton;
